export default "__VITE_ASSET__BtmTaMhg__"